import ResetPasswordCode from './reset-password-code';

export default ResetPasswordCode;
